import { render, staticRenderFns } from "./ClampedPortableText.vue?vue&type=template&id=978a3026&scoped=true"
import script from "./ClampedPortableText.vue?vue&type=script&lang=js"
export * from "./ClampedPortableText.vue?vue&type=script&lang=js"
import style0 from "./ClampedPortableText.vue?vue&type=style&index=0&id=978a3026&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978a3026",
  null
  
)

export default component.exports